import 'react';
import { VariantSwitcher } from '../../../VariantSwitcher/VariantSwitcher.js';
import { ProductBlockFooter as ProductBlockFooter$1 } from './ProductBlockFooter.js';

const ProductBlockFooter = Object.assign(ProductBlockFooter$1, {
    Variants: VariantSwitcher
});

export { ProductBlockFooter };
//# sourceMappingURL=index.js.map
